import {
  Component,
  Input
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReactiveFormsModule,
  FormGroup,
  FormsModule
} from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';

import {
  SWDynamicAutocompleteComponent
} from '../../../sw-autocomplete/sw-autocomplete.component';

import { LineCellBaseComponent }
from '../line-cell-base/line-cell-base.component';

@Component({
  selector:
    'app-line-cell-autocomplete',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatError,
    SWDynamicAutocompleteComponent
  ],

  templateUrl: './line-cell-autocomplete.component.html'
})
export class
LineCellAutocompleteComponent
extends LineCellBaseComponent {

  @Input()
  form!: FormGroup;

  get displayLabel(): string {

    const value =
      this.control?.value;

    if (!value) {
      return '';
    }

    // =====================================
    // OBJECT MODE
    // =====================================

    if (typeof value === 'object') {

      return (
        value.label ||

        value[this.col.dataSource?.labelField || 'name'] ||

        ''
      );
    }

    // =====================================
    // STRING MODE
    // =====================================

    return String(value);
  }
}